import { Component, OnInit } from '@angular/core';
import { Validators, FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Common } from 'utility/common';

@Component({
  selector: 'ngx-set-password',
  templateUrl: './set-password.component.html',
  styleUrls: ['./set-password.component.scss']
})
export class SetPasswordComponent implements OnInit {

  
  resetPasswordForm: any;
  loading = false;
  submitted = false;
  returnUrl: string;

  constructor(
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
  ) { }
 
  configerLoginDetails(){
    this.resetPasswordForm = this.formBuilder.group({
      password: ['', Validators.required],
      rePassword: ['', Validators.required]
  });
  }

  get f() { return this.resetPasswordForm.controls; }

  
  onSubmit() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.resetPasswordForm.invalid) {
        return;
    }
      this.loading = true;
      
  }

  ngOnInit(): void {
    Common.hideloader();
    this.configerLoginDetails();
  }



}
